import React, { useState, useEffect } from "react";
import { Button, TextField, Box, Grid, Typography, CircularProgress } from '@material-ui/core';
import authentication from "../../../services/authentication";
import * as Yup from 'yup';
import { Formik, useFormik, yupToFormErrors } from 'formik';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useHistory } from "react-router-dom";
import language from "../../../languages";
import firebase, { createUser } from "../../../firebase";

function MobileLogin(props) {
  const { classes, lang } = props
  let history  = useHistory();
  const [verifyResult, setVerifyResult] = useState('')
  const [countryCode, setCountryCode] = useState('+91');
  const [invalidPhoneMsg, setInvalidPhoneMsg] = useState({});
  const [verifying, setVerifying] = useState(false);

  useEffect(() => {
      window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
        'size': 'invisible',
        'callback': (response) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          // onSignInSubmit();
        }
      });
  }, [])

  const validationSchema = Yup.object({
    phoneNumber: Yup.string()
        .required('This field is required')
        .matches(/^[0-9]{10}$/g, 'Enter valid Phone Number'),
    password: Yup.string()
        .matches(/^[0-9]{6}$/g, 'Enter valid Phone Number'),
  })

  const validationSchema2 = Yup.object({
    phoneNumber: Yup.string()
        .required('This field is required')
        .matches(/^[0-9]{10}$/g, 'Enter valid Phone Number'),
    password: Yup.string()
        .required('This field is required')
        .matches(/^[0-9]{6}$/g, 'Enter valid Phone Number'),
  })

 const initialCredential = {
    phoneNumber: '',
    password: ''
 }

  const formik = useFormik({
    initialValues: initialCredential,
    enableReinitialize:true,
    validationSchema: verifyResult ? validationSchema2 : validationSchema || Yup.object({}),
    onSubmit: signInCredentials => {
        // props.toggleLoader(true)
        if(verifyResult)
          signInWithPhone(signInCredentials)
        else
          sendVerification(signInCredentials)
    },
  });

  const sendVerification = (signInCredentials) => {
    setVerifying(true)
    const appVerifier = window.recaptchaVerifier;
    firebase.auth().signInWithPhoneNumber(countryCode+signInCredentials.phoneNumber, appVerifier)
        .then((confirmationResult) => {
          // SMS sent. Prompt user to type the code from the message, then sign the
          // user in with confirmationResult.confirm(code).
          setVerifyResult(confirmationResult);
          setVerifying(false)
          // ...
        }).catch((error) => {
          // Error; SMS not sent
          // ...
          // console.log(error)
          setInvalidPhoneMsg(error)
          setVerifying(false)
        });
  }

  const signInWithPhone = async(signInCredentials) => {
    try{
      props.toggleLoader(true)
      setVerifying(true)
      await verifyResult.confirm(signInCredentials.password).then(async(result) => {
        // User signed in successfully.
        let user = result.user;
        // console.log(result)
        // console.log(user)
        // debugger
        if(result.additionalUserInfo?.isNewUser){
          user.firstName = null
          user.lastName = null
          // debugger
          await createUser(user)
        }

        // debugger
        setVerifying(false)
        props.toggleLoader(true)
        // ...
      }).catch((error) => {
        // User couldn't sign in (bad verification code?)
        // ...
        // console.log(error)
        setInvalidPhoneMsg(error)
        setVerifying(false)
        props.toggleLoader(true)
      });
    } catch(err) {
      console.log(err)
      setVerifying(false)
      props.toggleLoader(true)
    }
    
  }

  return (
    <React.Fragment>
        <div id='recaptcha-container'></div>
        <form onSubmit={formik.handleSubmit} >
        <div className={classes.root}>
          <Grid container justify="center" spacing={3}>
            <Grid item xs={12} sm={8} md={6} lg={4} className={classes.loginContainer}>
              <Box className={classes.paper} >

                <img src={process.env.PUBLIC_URL + "avvAppLogo.png"} alt="Logo Text" className={classes.image} />
                <Typography variant="h6" gutterBottom>{language[lang].Login_to_your_Account} </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  {verifyResult ? 'Now Enter the OTP send to your Phone Number to Login' : 'Please type your Phone Number to Continue'} :
                </Typography>
                <Grid container justify="center" alignItems="center" className={classes.inputGrid}>
                  <Grid item xs={4}>   
                    <Typography variant="subtitle2" className={classes.inputLabel}>Phone Number :</Typography>
                  </Grid>
                  <Grid item xs={1} ></Grid>
                  <Grid item xs={7}>   
                      <TextField
                        className={classes.singnUpInput}
                        color="secondary"
                        placeholder='Enter Your Phone Number'
                        id='phoneNumber'
                        disabled={(verifyResult || verifying) ? true : false}
                        value={formik.values.phoneNumber}
                        name='text'
                        type="phoneNumber"
                        inputProps={{maxLength: 10}}
                        size="small"
                        {...formik.getFieldProps('phoneNumber')}
                        error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                        helperText={formik.errors.phoneNumber}
                        onChange={formik.handleChange}
                    />
                  </Grid>
                </Grid>
                {verifyResult && <Grid container justify="center" alignItems="center" className={classes.inputGrid}>
                  <Grid item xs={4}>   
                    <Typography variant="subtitle2" className={classes.inputLabel}>OTP :</Typography>
                  </Grid>
                  <Grid item xs={1} ></Grid>
                  <Grid item xs={7}>   
                      <TextField 
                        className={classes.singnUpInput}
                        color="secondary"
                        placeholder='******'
                        id='password'
                        value={formik.values.password}
                        disabled={verifying ? true : false}
                        name='password'
                        type="password"
                        size="small"
                        {...formik.getFieldProps('password')}
                        error={formik.touched.password && Boolean(formik.errors.password)}
                        helperText={formik.errors.password}
                        onChange={formik.handleChange}
                    />
                  </Grid>
                </Grid>}
                <Grid container direction="row" justify="flex-end" alignItems="center" className={classes.forgotText}  >
                  {verifyResult && <Typography variant="body2" > OTP not Received! </Typography>}
                  {verifyResult && <Button size="small" className={classes.resetButton} onClick={() => sendVerification({phoneNumber: formik.values.phoneNumber})} >
                    Resend OTP
                  </Button>}
                </Grid>

                <Grid container direction="row" justify="center" alignItems="center"> 
                  <Button disabled={verifying} variant="contained" size="large" type="submit" className={classes.loginButton}>
                    {verifyResult ? language[lang].Log_in : 'Continue'} &nbsp; &nbsp; &nbsp; &nbsp; 
                    {verifying ? <CircularProgress size={24} color="inherit" /> : <ArrowForwardIosIcon fontSize="small" />} 
                  </Button>
                </Grid>

                <Grid container direction="row" justify="center" alignItems="center" className={classes.registerText}  >
                  <Typography variant="body2" > {language[lang].No_Account} </Typography>
                  <Button size="small" className={classes.resetButton} onClick={() => history.push('/signUp')}   >
                    {language[lang].Register_account}
                  </Button>
                  <Typography variant="body2" > OR </Typography>
                  <Button size="small" className={classes.resetButton} onClick={() => history.push('/signIn')}   >
                    Email Login
                  </Button>
                </Grid>

              </Box>
            </Grid>
          </Grid>
        </div>
        </form>
      
    </React.Fragment>
  );
}

export default MobileLogin